// ------------------------------------
// Funções Úteis
// ------------------------------------

// Debounce (Melhora a performance de funções repetitivas como "Scroll / Resize")
const debounce = function (n, t, u) {
  var e;
  return function () {
    var a = this,
      i = arguments,
      o = function () {
        (e = null), u || n.apply(a, i);
      },
      r = u && !e;
    clearTimeout(e), (e = setTimeout(o, t)), r && n.apply(a, i);
  };
};

// Verifica o tamanho da tela de acordo com o tipo passado
function isMedia(media) {
  media = media.trim().toLowerCase();
  const size = $(window).width();
  const validations = {
    xs: size <= 480,
    sm: size > 480 && size <= 768,
    md: size > 768 && size <= 945,
    lg: size > 940 && size <= 1280,
    xl: size > 1280,
  };
  return validations[media];
}

// Retorna o tamanho da tela
function getMedia() {
  const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
  return sizes.filter((sizeItem) => isMedia(sizeItem))[0];
}

// Copia uma string para a área de transferência
function copyToClipboard(str) {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
}

// Valida CPF
function isValidCPF(r) {
  var t, a, n, e, i;
  if (((i = 1), (r = r.replace(/[^\d]+/g, '')).length != 11)) return !1;
  for (e = 0; e < r.length - 1; e++)
    if (r.charAt(e) != r.charAt(e + 1)) {
      i = 0;
      break;
    }
  if (i) return !1;
  for (t = r.substring(0, 9), a = r.substring(9), n = 0, e = 10; e > 1; e--) n += t.charAt(10 - e) * e;
  if ((n % 11 < 2 ? 0 : 11 - (n % 11)) != a.charAt(0)) return !1;
  for (t = r.substring(0, 10), n = 0, e = 11; e > 1; e--) n += t.charAt(11 - e) * e;
  return (n % 11 < 2 ? 0 : 11 - (n % 11)) == a.charAt(1);
}

// Valida CNPJ
function isValidCNPJ(r) {
  if ('' == (r = r.replace(/[^\d]+/g, ''))) return !1;
  if (14 != r.length) return !1;
  if (
    '00000000000000' == r ||
    '11111111111111' == r ||
    '22222222222222' == r ||
    '33333333333333' == r ||
    '44444444444444' == r ||
    '55555555555555' == r ||
    '66666666666666' == r ||
    '77777777777777' == r ||
    '88888888888888' == r ||
    '99999999999999' == r
  )
    return !1;
  for (var t = r.length - 2, n = r.substring(0, t), a = r.substring(t), e = 0, i = t - 7, u = t; u >= 1; u--)
    (e += n.charAt(t - u) * i--), i < 2 && (i = 9);
  var f = e % 11 < 2 ? 0 : 11 - (e % 11);
  if (f != a.charAt(0)) return !1;
  for (t += 1, n = r.substring(0, t), e = 0, i = t - 7, u = t; u >= 1; u--)
    (e += n.charAt(t - u) * i--), i < 2 && (i = 9);
  return (f = e % 11 < 2 ? 0 : 11 - (e % 11)) == a.charAt(1);
}

// Valida CPF ou CNPJ
function isValidCPForCNPJ(value) {
  return isValidCPF(value) || isValidCNPJ(value);
}

// Valida e-mail
function isValidEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

// Formata um valor para real (R$)
function formatMoneyBR(v, c, d, t) {
  var n = v,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? ',' : d,
    t = t == undefined ? '.' : t,
    s = n < 0 ? '-' : '',
    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + '',
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
}

// Formata um valor em real (R$) para o formato do banco
function formatMoneyBD(value) {
  return value.replace('.', '').replace(',', '.');
}

// Obtém a largura de um texto em pixels
function measureText(string, fontSize = 14, fontWeight = 400) {
  const $el = $('<div></div>');
  $el.css({
    position: 'absolute',
    top: -1000,
    left: -1000,
    visibility: 'hidden',
    'white-space': 'nowrap',
    'font-size': fontSize,
    'font-weight': fontWeight,
  });
  $el.text(string);
  $('body').append($el);
  const textWidth = $el.width();
  $el.remove();
  return textWidth;
}

// Remove tags html de uma string
function stripTags(string) {
  return string.replace(/<(.|\n)*?>/g, '');
}

// Remove o que não for número de uma string
function somenteNumeros(string) {
  return string.replace(/\D/g, '');
}

// Converte um texto markdown para html
function mdParse(string, inline = false) {
  if (!string) {
    string = '';
  }
  return !inline ? marked(string.trim()) : marked.parseInline(string.trim());
}

// Obtém a extensão de um arquivo
function getFileExt(fileName) {
  return fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
}

// Gera um número aleatório
function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

// Gera um slug
function slugify(text) {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');
}

// Gera o token aleatório
function generateToken(n = 10) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let token = '';
  for (let i = 0; i < n; i++) {
    token += chars[Math.floor(Math.random() * chars.length)];
  }
  return token + '-' + Date.now();
}

// Corrige o bug da altura do slick com altura automática
function slickFixHeight($el) {
  if ($el.length > 0) {
    setTimeout(() => {
      const curSlideHeight = $el.find('.slick-current').outerHeight();
      $el.find('.slick-list.draggable').height(curSlideHeight);
    }, 100);
  }
}

// Obtém um parâmetro da url
function getUrlParam(param) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(param);
}

// Cria/Atualiza um cookie
function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/';
}

// Obtém um cookie
function getCookie(cName) {
  const name = cName + '=';
  const cDecoded = decodeURIComponent(document.cookie);
  const cArr = cDecoded.split('; ');
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res;
}

// Converte Hexadecimal para RGBA (Para o efeito pulse na sombra)
function hexToRGBA(h, a = 1) {
  hex = hex.replace(/^#/, '');
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }
  if (hex.length !== 6) {
    return false;
    //throw new Error('Invalid HEX color.');
  }
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;
  if (rArr) {
    return {
      r,
      g,
      b,
      a,
    };
  }
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

// Converte Hexadecimal para RGB (Para o efeito pulse na sombra)
function hexToRGB(hex, rArr = false) {
  hex = hex.replace(/^#/, '');
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }
  if (hex.length !== 6) {
    return false;
    //throw new Error('Invalid HEX color.');
  }
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;
  if (rArr) {
    return {
      r,
      g,
      b,
    };
  }
  return `rgb(${r}, ${g}, ${b})`;
}

// Gera box-shadown com base nos parâmetros
function generateBoxShadown(hexColor, alphaColor, shadowSize) {
  const rgbaColor = hexToRGBA(hexColor, alphaColor);
  return '0px 0px ' + shadowSize + ' ' + rgbaColor;
}

function styleText(string) {
  if (!string) return '';
  return string
    .replace(/>>/gm, '<span style="color:var(--txt-alt-color);">')
    .replace(/\[\[/gm, '<span style="background-color:var(--txt-bg-color);">')
    .replace(/<</gm, '</span>')
    .replace(/\]\]/gm, '</span>');
}

// Retorna a data atual
function getCurDate() {
  const cd = new Date();
  const day = cd.getDate() >= 10 ? cd.getDate() : '0' + cd.getDate();
  let month = cd.getMonth() + 1;
  month = month >= 10 ? month : '0' + month;
  const year = cd.getFullYear();
  return day + '/' + month + '/' + year;
}

// Retorna a data atual por extenso
function getCurDateExt(date = null) {
  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];
  const dayWeeks = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
  const cd = date === null ? new Date() : date;
  const day = cd.getDate() >= 10 ? cd.getDate() : '0' + cd.getDate();
  return dayWeeks[cd.getDay()] + ', ' + day + ' de ' + months[cd.getMonth()] + ' de ' + cd.getFullYear();
}

// Adiciona dias a uma data
function addDays(date, days, format = false) {
  let dateObj;
  if (typeof date === 'string') {
    const parts = date.split('/');
    dateObj = new Date(parts[2], parts[0] - 1, parts[1]);
  } else if (date instanceof Date) {
    dateObj = new Date(date);
  } else {
    throw new Error('Data inválida.');
  }
  dateObj.setDate(dateObj.getDate() + days);
  if (format) {
    return dateObj.toLocaleDateString('pt-BR');
  }
  return dateObj;
}

// Subtrai dias a uma data
function subDays(date, days, format = false) {
  let dateObj;
  if (typeof date === 'string') {
    const parts = date.split('/');
    dateObj = new Date(parts[2], parts[0] - 1, parts[1]);
  } else if (date instanceof Date) {
    dateObj = new Date(date);
  } else {
    throw new Error('Data inválida.');
  }
  dateObj.setDate(dateObj.getDate() - days);
  if (format) {
    return dateObj.toLocaleDateString('pt-BR');
  }
  return dateObj;
}

// Calcula a diferença entre duas datas
function diffDates(date1, date2, unit = 'days') {
  let dateObj1, dateObj2;
  if (typeof date1 === 'string') {
    const parts1 = date1.split('/');
    dateObj1 = new Date(parts1[2], parts1[1] - 1, parts1[0]);
  } else if (date1 instanceof Date) {
    dateObj1 = new Date(date1);
  } else {
    throw new Error('Invalid format for date1. Please use a string in the format "DD/MM/YYYY" or a date object.');
  }
  if (typeof date2 === 'string') {
    const parts2 = date2.split('/');
    dateObj2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);
  } else if (date2 instanceof Date) {
    dateObj2 = new Date(date2);
  } else {
    throw new Error('Invalid format for date2. Please use a string in the format "DD/MM/YYYY" or a date object.');
  }
  const diff = Math.abs(dateObj2 - dateObj1);
  if (unit === 'hours') {
    return Math.round(diff / (1000 * 60 * 60));
  } else if (unit === 'days') {
    return Math.round(diff / (1000 * 60 * 60 * 24));
  } else {
    throw new Error('Invalid unit. Please specify "hours" or "days".');
  }
}

// Obtém os dados do GEO IP gravado no Cookie
/* function getGeoIP() {
  const geoCookie = getCookie('geoip');
  if (geoCookie) {
    return JSON.parse(geoCookie);
  }
  return false;
} */

// Substitui variáveis dinâmicas no texto
/* function stvReplace(string) {
  const geoIp = getGeoIP();
  const stv_estado = geoIp['regionName'] || '$estado';
  const stv_uf = geoIp['region'] || '$uf';
  const stv_cidade = geoIp['city'] || '$cidade';
  const stv_data = getCurDate();
  const stv_data_ext = getCurDateExt();
  return string
    .replace(/\$estado/gm, stv_estado)
    .replace(/\$uf/gm, stv_uf)
    .replace(/\$cidade/gm, stv_cidade)
    .replace(/\$data_ext/gm, stv_data_ext)
    .replace(/\$data/gm, stv_data);
} */

// Formatação dos textos
function fmtTxt(string, inline = false) {
  return mdParse(styleText(string), inline);
}

// Retorna uma data em um formato específico
function formataDataExt(data, formato = '{d}/{m}/{Y}') {
  let retorno = formato;
  const time = new Date(data);
  if (isNaN(time)) {
    return false;
  }
  const meses = {
    '01': 'Janeiro',
    '02': 'Fevereiro',
    '03': 'Março',
    '04': 'Abril',
    '05': 'Maio',
    '06': 'Junho',
    '07': 'Julho',
    '08': 'Agosto',
    '09': 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  };
  const diasSemana = [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
  ];
  const siglas = {
    // Dia do mês com zero à esquerda
    d: String(time.getDate()).padStart(2, '0'),
    // Dia da semana abreviado (3 letras)
    D: diasSemana[time.getDay()].substr(0, 3),
    // Dia do mês sem zero à esquerda
    j: time.getDate(),
    // Dia da semana completo
    l: diasSemana[time.getDay()],
    // Mês completo
    F: meses[String(time.getMonth() + 1).padStart(2, '0')],
    // Mês com zero à esquerda
    m: String(time.getMonth() + 1).padStart(2, '0'),
    // Mês abreviado (3 letras)
    M: meses[String(time.getMonth() + 1).padStart(2, '0')].substr(0, 3),
    // Ano completo (4 dígitos)
    Y: time.getFullYear(),
    // Ano abreviado (2 dígitos)
    y: String(time.getFullYear()).slice(-2),
    // Horas (Formato 24h)
    H: String(time.getHours()).padStart(2, '0'),
    // Minutos
    i: String(time.getMinutes()).padStart(2, '0'),
    // Segundos
    s: String(time.getSeconds()).padStart(2, '0'),
  };
  for (const sigla in siglas) {
    if (siglas.hasOwnProperty(sigla)) {
      retorno = retorno.replace('{' + sigla + '}', siglas[sigla]);
    }
  }
  return retorno;
}

// Número aleatório que vai mudando
var rdnMin = 6;
var rdnMax = 24;
var rdnInterval = 10;
var rdnTimer;
function initRandNum() {
  if (rdnTimer !== undefined) {
    clearInterval(rdnTimer);
  }
  function randNumReplace() {
    $('.num-rand').each(function () {
      $(this).text(randomNumber(rdnMin, rdnMax));
    });
  }
  rdnTimer = setInterval(randNumReplace, rdnInterval * 1000);
}
initRandNum();

// Valida número do cartão de crédito (Algoritmo de Luhn)
function luhnValidate(value) {
  value = typeof value === 'number' ? value.toString() : value;
  let nCheck = 0;
  if (value && /[0-9-\s]+/.test(value)) {
    value = value.replace(/\D/g, '');
    value.split('').forEach((v, n) => {
      let nDigit = parseInt(v, 10);
      if (!((value.length + n) % 2) && (nDigit *= 2) > 9) {
        nDigit -= 9;
      }
      nCheck += nDigit;
    });
  }
  return nCheck % 10 === 0;
}

// Gera uma thumb
function getThumb(imageUrl, width = 0, height = 0, mode = '') {
  if (!imageUrl) {
    return null;
  }
  const url = `${urlBase}core/acoes/utils/thumb.php?img=${imageUrl}&width=${width}&height=${height}&mode=${mode}`;
  const request = new XMLHttpRequest();
  request.open('GET', url, false);
  request.send(null);
  if (request.status === 200) {
    return request.responseText;
  }
  return null;
}

// Converte um objeto em query string
function objToQueryString(obj) {
  return Object.keys(obj)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    .join('&');
}

// Executa uma função após um script ser carregado
function loadScriptExt(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    //Others
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  if (document.querySelector('#external-js')) {
    document.getElementById('external-js').appendChild(script);
  } else {
    document.body.appendChild(script);
  }
}

// Remove acentos
function removeAccents(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
